import { securedAxiosInstance } from "../axios";
import { toSnakeCase } from "@estaly/ui";

class ContractDistributionsService {
  fetchIndex(params, includes = []) {
    return securedAxiosInstance.get("/contract_distributions", { params: { ...toSnakeCase(params), includes } });
  }

  fetch(id, includes = []) {
    return securedAxiosInstance.get(`/contract_distributions/${id}`, { params: { includes } });
  }

  update(id, data) {
    return securedAxiosInstance.put(`/contract_distributions/${id}`, toSnakeCase(data));
  }
}

export default new ContractDistributionsService();
